import cn from 'classnames';
import { ReactNode } from 'react';
import styles from './status-message.module.scss';

export type StatusMessageStatus = 'destructive' | 'success' | 'warning' | 'default';
type StatusMessageProps = {
    status?: StatusMessageStatus;
    title?: ReactNode
    children: ReactNode
    className?: string
}


export function StatusMessage ({ status = 'success', title, children, className }: StatusMessageProps) {
    return (
        <div className={ cn(styles.root, { [styles[status]]: status }, className) }>
            { title }

            { children }
        </div>
    );
}
